import { render, staticRenderFns } from "./CatalogMap.vue?vue&type=template&id=669cc922&"
import script from "./CatalogMap.vue?vue&type=script&lang=js&"
export * from "./CatalogMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports